import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { User } from '../_models/user';
import { OperatorModel } from '../_models/operator-model';
import { AuthenticationService } from '../_services/authentication.service';
import { UserAccountService } from '../_services/user-account.service';
import { OperatorService } from '../_services/operator.service';
import { debounceTime, filter } from 'rxjs/operators';

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.css']
})
export class UserSettingsComponent implements OnInit {

  public userModel: User;
  public changePasswordForm: FormGroup;

  public operatorsForm: FormGroup;
  selectedOperators: Array<OperatorModel> = new Array<OperatorModel>();
  operatorCandidates: Array<OperatorModel>;

  public approvedOperators: Array<OperatorModel> = new Array<OperatorModel>();

  operatorsFormModel: any = {
    searchOperatorNumber: "",
    selectedOperators: []
  };

  public changePasswordModel: any = {
    oldPassword: "",
    newPassword: "",
    repeatNewPassword: ""
  };

  constructor(public userAccountService: UserAccountService,
    public authenticationService: AuthenticationService,
    public operatorService: OperatorService,
    public formBuilder: FormBuilder,
    public dialog: MatDialog
  )
  {
    this.userModel = this.authenticationService.currentUserSubject.value;

    this.userAccountService.fetchOperatorsForUser(this.userModel.Id).then(
      (operators) => {
        this.approvedOperators = operators;
      }
    );
  }

  ngOnInit(): void {

    function changePasswordValidator() {
      return function (control: AbstractControl) {
        var ret: any = {};

        if (control.get("newPassword").value != control.get("repeatNewPassword").value) {
          ret.passwordMismatch = true
        }

        if (control.get("newPassword").value.length < 8 ||
          control.get("repeatNewPassword").value.length < 8) {
          ret.passwordInvalid = true;
        }

        return ret;
      }
    }
    

    this.changePasswordForm = this.formBuilder.group({
      'oldPassword': [this.changePasswordModel.oldPassword, [Validators.required]],
      'newPassword': [this.changePasswordModel.newPassword, [Validators.required]],
      'repeatNewPassword': [this.changePasswordModel.repeatNewPassword, [Validators.required]]
    }, {
      validator: changePasswordValidator()
    });


    function selectedOperatorsValidator() {
      return (control: AbstractControl) => {
        var ret: any = {};

        var operatorsArray = control.value;

        if (operatorsArray.length != null && operatorsArray.length == 0) {
          ret.noOperators = true;
        }

        return ret;
      };
    }


    this.operatorsForm = this.formBuilder.group({
      'searchOperatorNumber': [this.operatorsFormModel.searchOperatorNumber, []],
      'selectedOperators': [this.selectedOperators, [selectedOperatorsValidator()]]
    }, {

    });
  }

  updateOperatorSearchResults(currentVal) {
    //Perform the search
    this.operatorService.searchByP5Number(currentVal).then((operCandidates: Array<OperatorModel>) => {
      this.operatorCandidates = operCandidates;
    },
      (err) => {
      });
  }

  ngAfterViewInit() : void {
    this.operatorsForm.get("searchOperatorNumber").valueChanges.pipe(filter((val) => val.length === 6),
      debounceTime(500)).subscribe((x) => {
        this.updateOperatorSearchResults(x);
      });
  }

  changePassword() {

    var submitModel = this.changePasswordForm.value;

    this.userAccountService.changePassword(this.userModel.Id, submitModel.oldPassword, submitModel.newPassword).then((result) => {
      if (result.Success) {
        this.dialog.open(MessageDialogComponent, {
          data: {
            title: "Success",
            message: "Your password has been changed.  You will need to log in with the new password again."
          }
        });
      }
    },
    (err) => {
    });
  }

  selectOperator(oper) {
    var found = this.selectedOperators.find((x: OperatorModel) => {
      var ret = false;

      if (x.Id == oper.Id) {
        ret = true;
      }

      return ret;
    });

    if (found == null) {
      this.selectedOperators.push(oper);

      this.operatorsForm.get("selectedOperators").setValue(this.selectedOperators);
    }
  }

  removeOperator(oper) {
    var ind = this.selectedOperators.indexOf(oper);

    this.selectedOperators.splice(ind, 1);

    this.operatorsForm.get("selectedOperators").setValue(this.selectedOperators);
  }

  userHasThisOperator(operator) {
    var ret = false;

    for (var i = 0; i < this.approvedOperators.length; i++) {
      var approvedOperator = this.approvedOperators[i];

      if (operator.Id == approvedOperator.Id) {
        ret = true;
      }
    }

    return ret;
  }

  requestSelectedOperators() {
    if (this.operatorsForm.valid) {

      var userId = this.userModel.Id;
      var operatorIds = [];

      for (var i = 0; i < this.selectedOperators.length; i++) {
        var operator = this.selectedOperators[i].Id;
        operatorIds.push(operator);
      }

      this.userAccountService.requestNewOperatorsForUser(userId, operatorIds).then(() => {
        //If we had a success message, display the confirmation dialog, which talks about how
        this.dialog.open(MessageDialogComponent, {
          data: {
            title: "Request Completed",
            message: "Your request to join additional operators has been received and the designated approver for each operator has been notified.  You will be notified when each request is approved."
          }
        }).afterClosed().subscribe(() => {
          //Clear out the selected operators.
          this.selectedOperators.splice(0, this.selectedOperators.length);
        });
      },
        () => {
          this.dialog.open(MessageDialogComponent, {
            data: {
              title: "Error",
              message: "An error occurred while attempting process your request.  You can try clicking on the submit button again, but if this problem persists, you should contact the administrator."
            }
          });
      });
    }
  }
}
